document.addEventListener("DOMContentLoaded",()=>{

    new Ajaxinate({
      container: '#product-grid',
      pagination: '#AjaxinatePagination',
      method: "click",
      loadingText: "Load More",
      callback: function() {
        document.getElementById("loading-status").style.display = "none";
        document.dispatchEvent(new CustomEvent('hbShowColorSwatch:init'))
        document.dispatchEvent(new CustomEvent('dShowColorSwatch:init'))
        document.dispatchEvent(new CustomEvent('productCartFunctions:init'))
      }
    });

});


window.checkDataLoaded = () => {
  let loadingStatus = document.getElementById('loading-status').style.display;

  if (loadingStatus === 'none') {
    let productGrid = document.getElementById('product-grid');
    let collectionHandle = productGrid.getAttribute('collection');
    let cardItems = productGrid.querySelectorAll('.grid__item');
    let quickAddModalContainer = document.querySelectorAll('quick-add-modal.quick-add-modal');

    let cardItemsArray = Array.from(cardItems).map(item => ({ element: item, html: item.outerHTML }));
    let AddModalArray = Array.from(quickAddModalContainer).map(itemModal => ({ element: itemModal, html: itemModal.outerHTML }));

    sessionStorage.setItem('cardItemsArray', JSON.stringify(cardItemsArray));
    sessionStorage.setItem('AddModalArray', JSON.stringify(AddModalArray));
    sessionStorage.setItem('LoadMoreContent', 'true');
    sessionStorage.setItem('CollectionHandle', collectionHandle);

    return;
  } else {
    setTimeout(checkDataLoaded, 1000);
  }
}

function updateLoadingStatus() {
  let paginationUrl = document.querySelector('#AjaxinatePagination a').getAttribute('href');
  if (paginationUrl != null) {
    let updatedPaginationUrl = `https://fleurdumal.com${paginationUrl}`;
    /*window.history.replaceState({}, document.title, updatedPaginationUrl);*/
  }
  document.getElementById("loading-status").style.display = "block";
  checkDataLoaded();
}

window.scrollToViewProduct = ()=>{
  let anchor = sessionStorage.getItem("pdpItemLink");
  let targetElement = document.querySelector(`[datatitle="${anchor}"]`);
  if (targetElement) {
    targetElement.scrollIntoView({ behavior: 'smooth' });
    setTimeout(() => {
      const scrollPosition = window.scrollY - 350;
      window.scrollTo({
        top: scrollPosition,
        behavior: 'smooth'
      });
    }, 1000);
  }
}

window.getSessionStoredData = ()=>{
  let storedCollectionHandle = sessionStorage.getItem('CollectionHandle');
  let collectionHandle = document.getElementById('product-grid').getAttribute('collection');
  let loadMoreContent = sessionStorage.getItem('LoadMoreContent');

  if(loadMoreContent === 'true' && storedCollectionHandle === collectionHandle) {
    let liElements = document.querySelectorAll('#product-grid li');
    liElements.forEach(li => li.remove());

    let collectionCard = JSON.parse(sessionStorage.getItem('cardItemsArray'));
    let addModalArray = JSON.parse(sessionStorage.getItem('AddModalArray'));

    let htmlContent = collectionCard.map(item => item.html).join('');
    let htmlContentModal = addModalArray.map(modal => modal.html).join('');

    let productGrid = document.querySelector('#product-grid');
    productGrid.innerHTML = htmlContent + productGrid.innerHTML;

    let addModalContainer = document.querySelector('quick-add-modal.quick-add-modal');
    addModalContainer.insertAdjacentHTML('beforebegin', htmlContentModal);

    document.querySelectorAll('.quick-add modal-opener button[vwo-el-id]').forEach(item => item.remove());
  }
  if (/iPhone/.test(navigator.userAgent)) {
    setTimeout(scrollToViewProduct, 2000);
  }
  sessionStorage.removeItem('LoadMoreContent');
  sessionStorage.removeItem('cardItemsArray');
  sessionStorage.removeItem('CollectionHandle');
  sessionStorage.removeItem('AddModalArray');
}
getSessionStoredData();

const grid_switcher_options = document.querySelectorAll(".grid-switcher-option");

grid_switcher_options?.forEach(grid_switcher_option => {
  grid_switcher_option.addEventListener('click', ()=>{
    document.getElementById("collection_loader").style.display = "block";

    document.querySelector("#two-grid-switcher").classList.remove("active");
    document.querySelector("#three-grid-switcher").classList.remove("active");
    document.querySelector("#four-grid-switcher").classList.remove("active");

    grid_count = grid_switcher_option.getAttribute("grid_count");
    grid_switcher_option.classList.add("active");
    let url = window.location.href;

    if (url.includes("?") == false) {
      url_string = url + "?view_on=" + grid_count;
    } else {
      if (url.includes("view_on") == false) {
        url_string = url + "&view_on=" + grid_count;
      } else {
        url_string = url.replace(/view_on=\d/, "view_on=" + grid_count);
      }
    }
    document.getElementById("view_on").value = grid_count;
    document.getElementById("product-grid").classList.remove("grid--2-col-tablet", "grid--2-col-desktop", "grid--3-col-tablet", "grid--3-col-desktop", "grid--4-col-tablet", "grid--4-col-desktop");
    document.getElementById("product-grid").classList.add("grid--" + grid_count + "-col-tablet", "grid--" + grid_count + "-col-desktop");

    var search_params = url_string.split("?")[1];
    /*history.pushState(search_params,'',url_string,);*/
    //window.location.assign(url_string);

    document.getElementById("collection_loader").style.display = "none";
  });
});
